<template>
  <div class="content_main">
    <div class="content_main_top">
      <a-input placeholder="请输入角色名称" class="a_input_self margin_self" v-model="queryParam.roleName" @keyup.enter.native="$refs.table.refresh(true)" />
      <a-select placeholder="请选择状态" class="a_input_self margin_self" v-model="queryParam.status" default-value="0" @keyup.enter.native="$refs.table.refresh(true)">
        <a-select-option :value="''">全部</a-select-option>
        <a-select-option :value="0">正常</a-select-option>
        <a-select-option :value="1">禁用</a-select-option>
      </a-select>
      <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
      <a-button style="margin-left: 8px" @click="() => (queryParam = {})">重置</a-button>
      <a-button v-if="addEnable" type="primary" icon="plus" @click="$refs.modal.add()">新建</a-button>
      <a-dropdown v-if="removeEnable && selectedRowKeys.length > 0">
        <!-- <a-menu slot="overlay">
          <a-menu-item key="1"><a-icon type="delete" />删除</a-menu-item>
          <a-menu-item key="2"><a-icon type="lock" />禁用</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down" />
        </a-button> -->
        <a-button type="danger" icon="delete" @click="delByIds(selectedRowKeys)">删除</a-button>
      </a-dropdown>
    </div>
    <div class="content_main_center_scroll" id="content_main_center">
      <s-table
        size="default"
        ref="table"
        rowKey="roleId"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :columns="columns"
        :data="loadData"
        defaultSort="createTime"
        :scroll="{ y: scroll_y }"
      >
        <span slot="status" slot-scope="text, record">
          <a-switch :checked="record.status == 0" @change="onChangeStatus(record)" />
        </span>
        <span slot="action" slot-scope="text, record">
          <a v-if="editEnabel" @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a v-if="editEnabel" @click="handleScope(record)">数据权限</a>
          <a-divider type="vertical" />
          <a v-if="removeEnable" @click="delByIds([record.roleId])">删除</a>
        </span>
      </s-table>
    </div>

    <role-modal ref="modal" @ok="handleOk" />
    <role-scope-modal ref="scopemodal" @ok="handleOk" />
  </div>
</template>

<script>
import { STable } from '@/components'
import { getRoleList, delRole, changRoleStatus } from '@/api/system'
import RoleModal from './modules/RoleModal.vue'
import RoleScopeModal from './modules/RoleScopeModal.vue'
import pick from 'lodash.pick'
import { checkPermission } from '@/utils/permissions'
export default {
  name: 'TableList',
  components: {
    STable,
    RoleModal,
    RoleScopeModal,
  },
  data() {
    return {
      description:
        '列表使用场景：后台管理中的权限管理以及角色管理，可用于基于 RBAC 设计的角色权限控制，颗粒度细到每一个操作类型。',
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      form: this.$form.createForm(this),
      mdl: {},
      permissions: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '角色编号',
          dataIndex: 'roleId',
        },
        {
          title: '角色名称',
          dataIndex: 'roleName',
        },
        {
          title: '权限字符',
          dataIndex: 'roleKey',
        },
        {
          title: '显示顺序',
          dataIndex: 'roleSort',
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          sorter: true,
        },
        {
          title: '操作',
          width: '200px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        return getRoleList(Object.assign(parameter, this.queryParam))
      },
      selectedRowKeys: [],
      selectedRows: [],
      addEnable: checkPermission('system:role:add'),
      editEnabel: checkPermission('system:role:edit'),
      removeEnable: checkPermission('system:role:remove'),
    }
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      var max_h = $('#content_main_center').height() 
      setTimeout(() => {
        this.scroll_y = max_h - $('.ant-table-header').height()-50
        this.$forceUpdate()
      }, 1000)
    })
  },
  methods: {
    onSelectChange(selectedRowKeys) {
      console.log('selectedRowKeys changed: ', selectedRowKeys)
      this.selectedRowKeys = selectedRowKeys
    },
    handleAdd(parentId) {
      this.$refs.modal.add(parentId)
    },
    handleEdit(record) {
      this.$refs.modal.edit(record)
    },
    handleScope(record) {
      this.$refs.scopemodal.edit(record)
    },
    onChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    handleOk() {
      this.$refs.table.refresh(true)
      console.log('handleSaveOk')
    },
    delByIds(ids) {
      delRole({ ids: ids.join(',') }).then((res) => {
        if (res.code === 200) {
          this.$message.success(`删除成功`)
          this.handleOk()
        } else {
          this.$message.error(res.msg)
        }
        // const difference = new Set(this.selectedRowKeys.filter(x => !new Set(ids).has(x)))
        // this.selectedRowKeys = Array.from(difference)
        this.selectedRowKeys = []
      })
    },
    onChangeStatus(record) {
      record.status = record.status === '0' ? '1' : '0'
      changRoleStatus(pick(record, 'roleId', 'status'))
      // 发送状态到服务器
    },
  },
  watch: {
    /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
  },
}
</script>
